<template>
    <AppLayout>
        <PageHero title="Privacy Policy" description="How we collect, use, and protect your information." />

        <Container>
            <div class="cms-content mx-auto max-w-3xl py-16" v-html="privacyPolicy ? privacyPolicy.content : '...'"></div>
        </Container>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import Container from '@/components/ui/Container.vue';
import PageHero from '@/components/ui/PageHero.vue';
import { ref } from 'vue';
import { getPrivacyPolicy } from '@/services/pageService';

const privacyPolicy = ref(null);

const fetchPrivacyPolicy = async () => {
    const response = await getPrivacyPolicy();
    privacyPolicy.value = response.data;
}

fetchPrivacyPolicy();
</script>
